import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

//Include Both Helper File with needed methods
import {
  getLogin,
  postLogout,
} from "../../../helpers/backend_helper"
import apiClientInstance from "helpers/api_client"
import { storeTokenIssuedAt, clearSessionData } from "../../../helpers/session_helper"


function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(
      getLogin,
      {
        authMode: "password",
        userIdentity: user.username,
        userCredentials: user.password,
      }
    )
    localStorage.setItem("_atk", response.userCredentials)
    apiClientInstance.setAuth(response.userCredentials)
    storeTokenIssuedAt() // Store when the token was issued
    yield put(loginSuccess(response))

    history.push("/dashboard")
  } catch (error) {
    console.error("Error in loginUser saga:", error)
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    const response = yield call(postLogout)
    yield put(logoutUserSuccess(response))
    clearSessionData() // Clear all session data including times
    history.push("/login")
  } catch (error) {
    console.error("Error in logoutUser saga:", error)
    yield put(apiError(error))
    clearSessionData() // Clear session data even on error
    history.push("/pages-500")
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    // Social login not implemented - redirect to regular login
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
